import { ajax } from "../services/ajax";
import { api } from "../constants";

export const getMediumsList = () => ajax.get(`${api.endpoints.mediums.home.list}`);
export const getSingleMediumItems = () => ajax.get(`${api.endpoints.mediums.home.single.get}`);
export const saveMediumItems = data => {
  return ajax.post(api.endpoints.mediums.home.single.add, { data })
}
